<div class="loader-wrapper">
  <div class="loader-background"></div>
  <div class="loader-container">
    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div>
</div>
